module.exports = __webpack_public_path__ + "assets/img/savitarna-header.7891dee0.png";